"use client"

import { SavePill } from "@/app/(frontend)/[country]/[locale]/_components/membership-first/pricing/pricing-v5-booking"
import { usePricingV5Copy } from "@/app/(frontend)/[country]/[locale]/_components/membership-first/pricing/pricing-v5-copy"
import {
  IMAGING_KEYS,
  useCheckUp,
} from "@/app/(frontend)/[country]/[locale]/_components/membership-first/pricing/pricing-v5-shared"

/**
 * Save on a catalogue card: pricing v5's Save pill, into the same check-up
 * as the pricing lists, the test pages and the navbar (Eugene, 09.10). A
 * scan saves the full-body MRI with it when none is saved yet, as on the
 * test pages' HeroSaveButton. Nothing for a test the lists do not carry.
 */
export function CatalogueSave({ itemKey }: { itemKey: string }) {
  const { ADDONS, PICK, MRI } = usePricingV5Copy()
  const checkUp = useCheckUp()
  const item = ADDONS.groups
    .flatMap((group): { key: string; name: string }[] => group.items)
    .find((entry) => entry.key === itemKey)
  if (!item) return null
  return (
    <SavePill
      picked={checkUp.tests.includes(item.key)}
      onToggle={() => {
        if (
          !checkUp.tests.includes(item.key) &&
          IMAGING_KEYS.has(item.key) &&
          !checkUp.mri
        )
          // The package that holds the scans, Advanced (12.10).
          checkUp.toggleMri(
            (MRI.packages.find((p) => p.id === "advanced") ?? MRI.packages[0])
              .id
          )
        checkUp.toggleTest(item.key)
      }}
      labels={PICK}
      name={item.name}
    />
  )
}
